import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "title"
}
const _hoisted_2 = { class: "content" }

import { computed, ref, onMounted } from "vue";
import { useI18n } from "vue-i18n";

import { toast } from "@/common/utils/toast";

import {
  evaluationEquipmentCreate,
  evaluationEquipmentDelete,
  evaluationEquipmentList,
} from "@/common/api/rest/evaluation/equipment";

import type { EvaluationType } from "@/common/types/evaluation";
import type { EquipmentListType } from "@/common/types/equipment";

import { searchEquipment } from "@/components";
import { baseConfirm, baseModal, baseTable } from "@/common/components";


export default /*@__PURE__*/_defineComponent({
  __name: 'equipment',
  props: {
    data: {},
    width: { default: "100%" },
    showTitle: { type: Boolean, default: true },
    isEdit: { type: Boolean, default: true }
  },
  emits: ["update-data"],
  setup(__props: any, { emit: __emit }) {

const { t } = useI18n();

const emit = __emit;

const props = __props;

const tableHeader = computed(() => [
  { key: "code", label: t("common.labels.code") },
  { key: "name", label: t("common.labels.name") },
]);

const tableData = ref<EquipmentListType[]>([]);
const selected = ref<any>(null);
const selecteds = ref<any[]>([]);

const limit = ref<number>(5);
const page = ref<number>(0);
const pages = ref<number>(0);
const search = ref<string>("");
const searched = ref<number>(0);
const total = ref<number>(0);

const showModalAdd = ref(false);
const showDelConfirm = ref(false);

function fetchData() {
  if (!props.data) return;

  evaluationEquipmentList(props.data.account_id, {
    evaluation_id: props.data.evaluation_id,
    limit: limit.value,
    page: page.value,
    search: search.value,
  })
    .then((response) => {
      const { success, data, message } = response;

      if (success) {
        tableData.value = data.list;
        page.value = data.infos.page;
        pages.value = data.infos.pages;
        total.value = data.infos.total;
        searched.value = data.infos.count;
      } else {
        toast({ message: message, type: "error" });
      }
    })
    .catch(() => {
      toast({ message: t("error.default"), type: "error" });
    });
}

function update() {
  emit("update-data");
}

function add() {
  showModalAdd.value = true;
  selected.value = null;
}

function addCancel() {
  selecteds.value = [];
  showModalAdd.value = false;
}

function addSelect(data: any[]) {
  selecteds.value = data;
}

function addConfirm() {
  if (!props.data || !selecteds.value.length) return;

  showModalAdd.value = false;

  const promises = selecteds.value.map((sl) =>
    evaluationEquipmentCreate(props.data.account_id, {
      evaluation_id: props.data.evaluation_id,
      equipment_id: sl.equipment_id,
    }),
  );

  Promise.all(promises)
    .then((responses) => {
      responses.forEach((response) => {
        const { success, message } = response;
        if (success) {
          toast({ message: message, type: "success" });
          addCancel();
          fetchData();
          update();
        } else {
          toast({ message: message, type: "error" });
        }
      });
    })
    .catch(() => {
      toast({ message: t("error.default"), type: "error" });
    });
}

function del(data: EquipmentListType) {
  selected.value = data;
  showDelConfirm.value = true;
}

function delCancel() {
  showDelConfirm.value = false;
  selected.value = null;
}

function delConfirm() {
  if (!props.data || !selected.value) return;

  showDelConfirm.value = false;

  evaluationEquipmentDelete(props.data.account_id, selected.value.item_id)
    .then((response) => {
      const { success, message } = response;
      if (success) {
        delCancel();
        fetchData();
        update();
      } else {
        toast({ message: message, type: "error" });
      }
    })
    .catch(() => {
      toast({ message: t("error.default"), type: "error" });
    });
}

function searchItem(value: string) {
  search.value = value;
  fetchData();
}

function changePage(value: number) {
  page.value = value;
  fetchData();
}

onMounted(() => {
  fetchData();
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", {
    class: _normalizeClass(["tab-component", { width: __props.width }])
  }, [
    (__props.showTitle)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, _toDisplayString(_unref(t)("common.labels.equipments")), 1))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_unref(baseTable), {
        header: tableHeader.value,
        data: tableData.value,
        limit: limit.value,
        page: page.value,
        pages: pages.value,
        total: total.value,
        searched: searched.value,
        options: true,
        add: __props.isEdit,
        del: __props.isEdit,
        "onChange:page": changePage,
        onSearching: searchItem,
        "onBtn:add": _cache[0] || (_cache[0] = ($event: any) => (add())),
        "onBtn:del": del
      }, null, 8, ["header", "data", "limit", "page", "pages", "total", "searched", "add", "del"])
    ]),
    _createVNode(_unref(baseModal), {
      show: showModalAdd.value,
      title: 
        _unref(t)('common.labels.add', {
          concat: _unref(t)('common.labels.equipment'),
        }).toUpperCase()
      ,
      "show-button-confirm": true,
      "button-confirm": _unref(t)('common.labels.add'),
      "button-close": _unref(t)('common.labels.cancel'),
      onClose: _cache[1] || (_cache[1] = ($event: any) => (addCancel())),
      onConfirm: _cache[2] || (_cache[2] = ($event: any) => (addConfirm()))
    }, {
      content: _withCtx(() => [
        _createVNode(_unref(searchEquipment), {
          "account-id": __props.data?.account_id,
          ids: tableData.value.map((item) => item.equipment_id),
          onUpdateData: addSelect
        }, null, 8, ["account-id", "ids"])
      ]),
      _: 1
    }, 8, ["show", "title", "button-confirm", "button-close"]),
    _createVNode(_unref(baseConfirm), {
      show: showDelConfirm.value,
      "max-width": "400px",
      title: 
        _unref(t)('common.labels.remove', {
          concat: _unref(t)('common.labels.equipment'),
        }).toUpperCase()
      ,
      message: 
        _unref(t)('common.texts.remove_message', {
          concat: selected.value?.code,
        })
      ,
      onCancel: delCancel,
      onConfirm: delConfirm
    }, null, 8, ["show", "title", "message"])
  ], 2))
}
}

})